import { twJoin } from "tailwind-merge";
import { useState } from "react";
import JobCategory, { JobCategoryType } from "../components/JobCategory";
import SectionList from "../components/job-category/SectionList";

const JobCategoryPage = () => {
  const [data, setData] = useState<JobCategoryType>({
    id: 0,
    title_en: "",
    title_sc: "",
    title_tc: "",
  });
  const [showList, setShowList] = useState<boolean>(true);

  return (
    <div
      className={twJoin(
        "text-left bg-white sm:mt-[25px] mt-0 font-poppins text-13 font-semibold text-[#858795] tracking-[-0.03rem] w-full h-full rounded-xl pb-8 sm:pb-9 "
      )}
    >
      <SectionList/>
    </div>
  );
};
export default JobCategoryPage;
